import { render, staticRenderFns } from "./RepCursosDep.vue?vue&type=template&id=97b63cac&"
import script from "./RepCursosDep.vue?vue&type=script&lang=js&"
export * from "./RepCursosDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports